export default {
  'Arial': 'arial, helvetica, sans-serif',
  'Arial Black': "'arial black', 'avant garde'",
  'Cosmic Sans MS': "'comic sans ms', sans-serif",
  'Courier New': "'courier new', courier",
  'Georgia': "georgia, palatino",
  'Helvetica': "helvetica",
  'Inter': "inter, sans-serif",
  'Lato': "lato, sans-serif",
  'Poppins': "poppins, sans-serif",
  'Proxima Nova': "proxima-nova, sans-serif",
  'Symbol': "symbol",
  'Tahoma': "tahoma, arial, helvetica, sans-serif",
  'Times New Roman': "'times new roman', times",
  'Trebuchet MS': "'trebuchet ms', geneva",
  'Verdana': "verdana, geneva"
}
